import { FlowStatusEnum } from '@/pages/processApproval/type';
import { getPageModuleListWaitAudit } from '@/services/obas-api/flowApprove';
import { createWithEqualityFn } from 'zustand/traditional';

interface CountState {
  count: number;
  setcount: (val: number) => void;
  getcount: () => Promise<void>;
}
export const usecount = createWithEqualityFn<CountState>((set, get) => ({
  count: 0,
  setcount: (val: number | null) => {
    set({ count: val || 0 });
  },
  getcount: async () => {
    const res = await getPageModuleListWaitAudit({
      pageNum: 1,
      pageSize: 0,
      checkStatus: FlowStatusEnum.WaitAudit,
    });
    set({ count: res?.data?.totalCount || 0 });
  },
}));
